import { createSlice } from '@reduxjs/toolkit';
// Slice dla aktywnej zakładki w użytkownikach
const opinionsTTabSlice = createSlice({
  name: 'opinionsTTab', // Nazwa slice'a
  initialState: {
    rows: [],
    checkedItems: [], // Lista zaznaczonych checkboxów
    currentPage: 1, // Domyślna strona
    maxPages: 2, // Domyślna maksymalna liczba stron
    sortBy: null,
    sortDirection: null, // Domyślny kierunek sortowania
    
    addModalOpen: false, // Stan modala dodawania

    keyword: '', // Wyszukiwana fraza
    searchValue: '', // Wartość wyszukiwania

    editModalOpen: false, // Stan modala edycji
    editedSport: null, // Dane edytowanego sportu
    needRefresh: 1, // Flaga do wymuszenia odświeżenia
  },
  reducers: {
    setSortListEndpointT: (state, action) => {
      state.sortSortListEndpoint = action.payload; // Ustawienie endpointu sortowania
    },
    toggleNeedRefreshT: (state) => {
      state.needRefresh = state.needRefresh === 1 ? 0 : 1; // Przełączanie flagi odświeżenia
    },
    toggleCheckedItemT: (state, action) => {
      const id = action.payload;
      if (state.checkedItems.includes(id)) {
        // Usuń id, jeśli już istnieje
        state.checkedItems = state.checkedItems.filter((item) => item !== id);
      } else {
        // Dodaj id, jeśli nie istnieje
        state.checkedItems.push(id);
      }
    },
    setPageT(state, action) {
          state.checkedItems = []; // Resetowanie zaznaczonych elementów przy zmianie strony
          state.currentPage = action.payload;
        },
    setRowsT(state, action) {
      state.rows = action.payload; // Aktualizacja maksymalnej liczby stron
    },
    setMaxPagesT(state, action) {
          state.maxPages = action.payload; // Aktualizacja maksymalnej liczby stron 
        },
    setSortingT(state, action) {
        state.checkedItems = []; // Resetowanie zaznaczonych elementów przy zmianie strony
        const { sortBy, sortDirection } = action.payload;
        state.sortBy = sortBy;
        state.sortDirection = sortDirection;
      },
    toggleAddModalT(state) {
      state.addModalOpen = !state.addModalOpen; // Przełączanie stanu modala dodawania
    },
    toggleEditModalT(state, action) {
      state.editModalOpen = !state.editModalOpen;
      state.editedSport = action.payload || null; // Ustaw dane edytowanego sportu lub resetuj
    },
    clearCheckedItemsT: (state) => {
      state.checkedItems = []; // Resetowanie zaznaczonych elementów
    },
    setKeywordT: (state, action) => {
      state.keyword = action.payload; // Ustawienie wyszukiwanej frazy
    },
    setSearchValueT: (state, action) => {
      state.searchValue = action.payload; // Ustawienie wartości wyszukiwania
    },
}});

export const {
  toggleNeedRefreshT,
  toggleCheckedItemT,
  setPageT,
  setMaxPagesT,
  setSortingT,
  toggleAddModalT,
  toggleEditModalT,
  clearCheckedItemsT,
  setKeywordT,
  setSearchValueT,
  setRowsT,
  toggleSortListEndpointT,
 } = opinionsTTabSlice.actions; // Eksport akcji
export default opinionsTTabSlice.reducer;